export const Locales = [
  { code: 'zh-HK', name: '繁體中文 (香港)' },
  { code: 'en-HK', name: 'English (Hong Kong)' }
] as const;

export const LocaleCodes: Array<(typeof Locales)[number]['code']> = ['zh-HK', 'en-HK'];

export const LanguageCodes = [...new Set(LocaleCodes.map(code => new Intl.Locale(code).language))];
